import { SVGProps } from "react";

export function EyeOff(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1480_16417)">
        <path
          d="M2 2.5L14 14.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.05598 7.55811C6.80579 7.80812 6.66516 8.14727 6.66504 8.50097C6.66491 8.85466 6.8053 9.19392 7.05531 9.44411C7.30532 9.69429 7.64448 9.83492 7.99817 9.83504C8.35186 9.83517 8.69112 9.69478 8.94131 9.44477"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.571 12.0662C10.4837 12.7995 9.29434 13.1669 7.99967 13.1669C5.33301 13.1669 3.11101 11.6115 1.33301 8.5002C2.24567 6.90354 3.27501 5.71687 4.42101 4.93954M6.24167 4.07687C6.81329 3.91335 7.40514 3.83143 7.99967 3.83354C10.6663 3.83354 12.8883 5.38887 14.6663 8.5002C14.1477 9.40754 13.5917 10.1829 12.9977 10.8255L6.24167 4.07687Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1480_16417">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
